import { styled } from "theme/default/styled";

export const SUsersChangeRowGroupInputIcon = styled.button`
  margin-left: 32px;
`;
